import { CleanCalculationsStore } from './CleanCalculationsStore';
import { ProductCalculationsStore } from './ProductCalculationsStore';
import { OptimizedCalculationsStore } from './OptimizedCalculationsStore.ts';
import { ScheduleCalculationsStore } from './ScheduleCalculationsStore';
import { BottleByRoomCalculationStore } from './BottleByRoomCalculationStore';
import { CleanByRoomStore } from './CleanByRoomStore';

// Create instances
export const cleanCalculationsStore = new CleanCalculationsStore();
export const productCalculationsStore = new ProductCalculationsStore();
export const optimizedCalculationsStore = new OptimizedCalculationsStore();
export const scheduleCalculationsStore = new ScheduleCalculationsStore();
export const bottleByRoomCalculationStore = new BottleByRoomCalculationStore();
export const cleanByRoomStore = new CleanByRoomStore();

// Export classes
export { CleanCalculationsStore } from './CleanCalculationsStore';
export { ProductCalculationsStore } from './ProductCalculationsStore';
export { OptimizedCalculationsStore } from './OptimizedCalculationsStore.ts';
export { ScheduleCalculationsStore } from './ScheduleCalculationsStore';
export { BottleByRoomCalculationStore } from './BottleByRoomCalculationStore';
export { CleanByRoomStore } from './CleanByRoomStore';

// Interface for calculation stores
export interface ICalculationStores {
  cleanCalculationsStore: CleanCalculationsStore;
  productCalculationsStore: ProductCalculationsStore;
  optimizedCalculationsStore: OptimizedCalculationsStore;
  scheduleCalculationsStore: ScheduleCalculationsStore;
  bottleByRoomCalculationStore: BottleByRoomCalculationStore;
  cleanByRoomStore: CleanByRoomStore;
}
